import React from "react";
import { createPortal } from "react-dom";
import { CSpinner } from "@coreui/react";

const AppLoader = ({ message, fullScreen = false }) => {
  if (fullScreen) {
    return createPortal(
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999,
          backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent background
        }}
      >
        <CSpinner color="primary" size="lg" />
      </div>,
      document.body
    );
  }

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "60vh" }} // adjust as needed for full/partial screen
    >
      <CSpinner color="primary" size="lg" />
    </div>
  );
};

export default AppLoader;
